import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import { set, toggle } from './vuex'
import time from './modules/time'
import settings from './modules/settings'
import users from './modules/users'
import orders from './modules/orders'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    time,
    settings,
    users,
    orders,
  },
  state: {
    appName: 'TSB Living Pickups',
    showSpinner: false,
    showSnackbar: false,
    snackbarText: '',
    snackbarIsError: false,
  },
  mutations: {
    toggleDrawer: toggle('drawer'),
    showSpinner: set('showSpinner'),
    showSnackbar: set('showSnackbar'),
    snackbarText: set('snackbarText'),
    snackbarIsError: set('snackbarIsError'),
  },
  actions: {
    handleSuccess(context, successMessage) {
      context.commit('showSnackbar', true)
      context.commit('snackbarText', successMessage)
      context.commit('snackbarIsError', false)
      context.commit('showSpinner', false)
    },

    handleError(context, error) {
      if (!error.response || error.response.status !== 400) {
        console.error(error)
      }
      context.commit('showSnackbar', true)
      context.commit('snackbarText', error.response ? error.response.data.Message : 'An error occurred')
      context.commit('snackbarIsError', true)
      context.commit('showSpinner', false)
    },
  },
  getters: {},
})
